import { useCallback, memo } from 'react'
import { setUserProperties } from 'utils/tracking/amplitude'
import ConditionalWrapper from 'components/ConditionalWrapper'
import PathChoiceFieldGroup from '../PathChoiceFieldGroup'
import { UserProperty } from '../../utils/tracking/amplitude/amplitude.interface'

interface Props {
  dependson?: string
}

const DebtorChoice = ({ dependson }: Props) => {
  const onChange = useCallback((count: number) => {
    setUserProperties({ [UserProperty.DebtorCount]: count })
  }, [])

  return (
    <ConditionalWrapper dependson={dependson}>
      <PathChoiceFieldGroup<number> path="debtors.count" onChange={onChange} />
    </ConditionalWrapper>
  )
}

export default memo(DebtorChoice)
